import React from "react";
import MapView from "../Features/Map/Component/MapView";

const MainMap: React.FC = () => {
  return <MapView />;
};

export default MainMap;
